import React, { useState } from 'react';
import { Input } from 'antd';

function SimpleInput(props) {
  const { id, text } = props.value;
  const { formData } = props.config;
  const { maxLength } = props;

  const [value, setValue] = useState(text);

  function updateFormData(newValue) {
    const matchedFormIndex = formData.findIndex((e) => e.id === id);
    formData[matchedFormIndex].name = {
      text: newValue,
      id,
    };
  }

  function handleChange(e) {
    const newValue = e.target.value;
    updateFormData(newValue);
    setValue(newValue);
  }

  return (
    <Input
      value={value}
      maxLength={maxLength}
      onChange={(e) => handleChange(e)}
    />
  );
}

export default SimpleInput;
